// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BorrowAppletAccessLoadEvent
 */
export var BorrowAppletAccessLoad = function (_a) {
    var source = _a.source;
    return ({
        name: "BorrowApplet Access Load",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "Access",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletAccessRouteEvent
 */
export var BorrowAppletAccessRoute = function (_a) {
    var source = _a.source, routeUrl = _a.routeUrl;
    return ({
        name: "BorrowApplet Access Route",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "Access",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            route_url: routeUrl !== undefined && routeUrl !== null ? routeUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletViewSeeTileEvent
 */
export var BorrowAppletViewSeeTile = function (_a) {
    var source = _a.source;
    return ({
        name: "BorrowApplet View SeeTile",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "View",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletViewLoanDetailsEvent
 */
export var BorrowAppletViewLoanDetails = function (_a) {
    var variant = _a.variant, loanToken = _a.loanToken;
    return ({
        name: "BorrowApplet View LoanDetails",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "View",
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            loan_token: loanToken !== undefined && loanToken !== null ? loanToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletViewBulletinSheetEvent
 */
export var BorrowAppletViewBulletinSheet = function (_a) {
    var identifier = _a.identifier;
    return ({
        name: "BorrowApplet View BulletinSheet",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "View",
            identifier: identifier !== undefined && identifier !== null ? identifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletViewUpsellCardEvent
 */
export var BorrowAppletViewUpsellCard = function (_a) {
    var routeUrl = _a.routeUrl, identifier = _a.identifier;
    return ({
        name: "BorrowApplet View UpsellCard",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "View",
            route_url: routeUrl !== undefined && routeUrl !== null ? routeUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            identifier: identifier !== undefined && identifier !== null ? identifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletViewBenefitLeafletEvent
 */
export var BorrowAppletViewBenefitLeaflet = function (_a) {
    var benefitType = _a.benefitType;
    return ({
        name: "BorrowApplet View BenefitLeaflet",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "View",
            benefit_type: benefitType !== undefined && benefitType !== null ? benefitType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletInteractTapBorrowButtonEvent
 */
export var BorrowAppletInteractTapBorrowButton = function () { return ({
    name: "BorrowApplet Interact TapBorrowButton",
    parameters: {
        cdf_entity: "BorrowApplet",
        cdf_action: "Interact",
    }
}); };
/**
 * @see BorrowAppletInteractTapBulletinEvent
 */
export var BorrowAppletInteractTapBulletin = function (_a) {
    var identifier = _a.identifier, routeUrl = _a.routeUrl;
    return ({
        name: "BorrowApplet Interact TapBulletin",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "Interact",
            identifier: identifier !== undefined && identifier !== null ? identifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            route_url: routeUrl !== undefined && routeUrl !== null ? routeUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletInteractTapBulletinSheetButtonEvent
 */
export var BorrowAppletInteractTapBulletinSheetButton = function (_a) {
    var identifier = _a.identifier, routeUrl = _a.routeUrl;
    return ({
        name: "BorrowApplet Interact TapBulletinSheetButton",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "Interact",
            identifier: identifier !== undefined && identifier !== null ? identifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            route_url: routeUrl !== undefined && routeUrl !== null ? routeUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletInteractTapPaymentEvent
 */
export var BorrowAppletInteractTapPayment = function (_a) {
    var routeUrl = _a.routeUrl;
    return ({
        name: "BorrowApplet Interact TapPayment",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "Interact",
            route_url: routeUrl !== undefined && routeUrl !== null ? routeUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletInteractTapPaymentTilePrimaryButtonEvent
 */
export var BorrowAppletInteractTapPaymentTilePrimaryButton = function (_a) {
    var routeUrl = _a.routeUrl;
    return ({
        name: "BorrowApplet Interact TapPaymentTilePrimaryButton",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "Interact",
            route_url: routeUrl !== undefined && routeUrl !== null ? routeUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletInteractTapLoanEvent
 */
export var BorrowAppletInteractTapLoan = function (_a) {
    var identifier = _a.identifier;
    return ({
        name: "BorrowApplet Interact TapLoan",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "Interact",
            identifier: identifier !== undefined && identifier !== null ? identifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowAppletInteractTapExpandLoansListEvent
 */
export var BorrowAppletInteractTapExpandLoansList = function () { return ({
    name: "BorrowApplet Interact TapExpandLoansList",
    parameters: {
        cdf_entity: "BorrowApplet",
        cdf_action: "Interact",
    }
}); };
/**
 * @see BorrowAppletInteractTapUpsellCardEvent
 */
export var BorrowAppletInteractTapUpsellCard = function (_a) {
    var routeUrl = _a.routeUrl, identifier = _a.identifier;
    return ({
        name: "BorrowApplet Interact TapUpsellCard",
        parameters: {
            cdf_entity: "BorrowApplet",
            cdf_action: "Interact",
            route_url: routeUrl !== undefined && routeUrl !== null ? routeUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            identifier: identifier !== undefined && identifier !== null ? identifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
